export enum CalendarUrlType {
  AGODA = 'AGODA',
  AIRBNB = 'AIRBNB',
  AIRHOST = 'AIRHOST',
  AIRHOST_CLEANING_TASKS = 'AIRHOST_CLEANING_TASKS',
  BEDS24 = 'BEDS24',
  BOOKING = 'BOOKING',
  DELTAHQ = 'DELTAHQ',
  GOOGLE_CALENDAR = 'GOOGLE_CALENDAR',
  GUESTY = 'GUESTY',
  HOSTEX = 'HOSTEX',
  OTHER = 'OTHER',
  PIPI_HOSTING = 'PIPI_HOSTING',
  RAKUTEN_OYADO = 'RAKUTEN_OYADO',
  SMARTORDER = 'SMARTORDER',
  VRBO = 'VRBO'
}

type SupportedCalendarUrlType = Exclude<CalendarUrlType, CalendarUrlType.OTHER>

// OTHER を除く全プラットフォームの表示用ラベル.
// enum に新しい値が追加された時はここで "Property 'XXX' is missing" のコンパイルエラーが出るため追従漏れを検出できる.
const CALENDAR_URL_TYPE_LABELS: Record<SupportedCalendarUrlType, string> =
  {
    [CalendarUrlType.AIRBNB]: 'Airbnb',
    [CalendarUrlType.BOOKING]: 'Booking.com',
    [CalendarUrlType.AGODA]: 'Agoda',
    [CalendarUrlType.VRBO]: 'VRBO',
    [CalendarUrlType.BEDS24]: 'Beds24',
    [CalendarUrlType.AIRHOST]: 'Airhost',
    [CalendarUrlType.AIRHOST_CLEANING_TASKS]: 'Airhost',
    [CalendarUrlType.HOSTEX]: 'Hostex',
    [CalendarUrlType.GUESTY]: 'Guesty',
    [CalendarUrlType.DELTAHQ]: 'Delta HQ',
    [CalendarUrlType.RAKUTEN_OYADO]: '楽天Oyado',
    [CalendarUrlType.GOOGLE_CALENDAR]: 'Googleカレンダー',
    [CalendarUrlType.SMARTORDER]: 'SmartOrder',
    [CalendarUrlType.PIPI_HOSTING]: 'PIPI'
  }

// 対応プラットフォームのサイト名を重複排除してカンマ区切りにした表示用テキスト.
export const SUPPORTED_CALENDAR_SITES_TEXT = Array.from(
  new Set(Object.values(CALENDAR_URL_TYPE_LABELS))
).join(', ')

// 未知の値 / OTHER は「その他」に倒す.
export const calendarUrlTypeLabel = (type: string | null) =>
  CALENDAR_URL_TYPE_LABELS[type as SupportedCalendarUrlType] ?? 'その他'
